const heroLayoutStyle = () => ({
  pageLayout: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },

  hero: {
    width: '100%',
    position: 'relative'
  },

  heroCta: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,

    '.heroCtaContent': {
      color: '#FFF',
      height: '100%',
      margin: 'auto',
      display: 'flex'
    }
  },

  body: {
    flexGrow: 1,
    paddingTop: 30,
    paddingBottom: 50
  }
});

export default heroLayoutStyle;
